<template>
  <aside
    :class="['race-select', { active: raceOverlayActive || yearOverlayActive }]"
  >
    <div
      class="race-select__inner"
      :style="{ height: innerHeight }"
      ref="inner"
    >
      <div
        :class="[
          'race-select__overlay race-select__overlay--season',
          { active: yearOverlayActive },
        ]"
        ref="overlayYear"
      >
        <template v-for="(season, index) in validSeasons">
          <button
            class="race-select__season"
            :key="season[index]"
            v-on:click="seasonSelected(season.season, index)"
          >
            {{ season.season }}
          </button>
        </template>
      </div>
      <div
        :class="['race-select__overlay', { active: raceOverlayActive }]"
        ref="overlayRace"
      >
        <template v-for="(race, index) in validRaces">
          <button :key="race[index]" v-on:click="raceRouting(index + 1)">
            {{ race.raceName }}
          </button>
        </template>
        <template v-for="(race, index) in invalidRaces">
          <span :key="race[index]">
            {{ race.raceName }}
            <br />
            <p>{{ race.date }}</p>
          </span>
        </template>
      </div>
    </div>
    <!-- <div class="race-select__wipe">
      <div class="race-select__gradient" ref="gradient"></div>
    </div>-->
  </aside>
</template>
<script>
import EventBus from '@/event-bus/event-bus.js'

export default {
  name: 'race-select',
  props: {
    race: [Object, Boolean],
    seasons: Array,
    latestRaceData: [Object, Boolean]
  },
  data () {
    return {
      seasonsFetched: false,
      activeSeason: '',
      activeRace: '',
      activeSeasonIndex: '',
      raceOverlayActive: false,
      yearOverlayActive: false,
      raceOverlayHeight: '',
      yearOverlayHeight: '',
      innerHeight: '',
      validRaces: [],
      invalidRaces: [],
      validSeasons: []
    }
  },
  created () {
    // Emitted from RaceHeader.vue
    EventBus.$on('raceSelectYearState', () => {
      this.raceSelectYearState()
    })

    // Set current race and year
    this.activeRace = this.race.round
    this.activeSeason = this.race.season

    // Emitted from RaceHeader.vue
    EventBus.$on('raceSelectRaceState', (bool) => {
      this.raceSelectRaceState(bool)
    })
  },
  mounted () {
    // Used later for filtering race data
    const year = parseInt(process.env.VUE_APP_CURRENT_SEASON)
    if (this.$route.name === 'latestRace') {
      this.mostRecentSeason = parseInt(this.race.season)
      this.mostRecentRound = parseInt(this.race.round)
    } else if (this.$route.name === 'otherRaces') {
      this.mostRecentRound = parseInt(this.latestRaceData.round)
      this.mostRecentSeason = parseInt(this.latestRaceData.season)
      if (year !== parseInt(this.latestRaceData.season)) {
        this.mostRecentRound = 1
        this.mostRecentSeason = parseInt(this.seasons[0].season)
      }
    }
    this.getCurrentYearRaces()
    this.seasonsFetched = true
    this.getValidSeasons()
    this.getValidRaces()
    this.getInvalidRaces()
  },
  methods: {
    raceSelectYearState () {
      if (this.$refs.overlayYear === undefined) return

      // get height and set state of race select year overlay
      const overlayHeight = this.$refs.overlayYear.offsetHeight
      this.yearOverlayHeight = `${overlayHeight}px`
      this.innerHeight = `${overlayHeight}px`
      this.raceOverlayActive = false
      !this.yearOverlayActive ? this.yearOverlayActive = true : this.yearOverlayActive = false

      // Reset styles
      if (!this.yearOverlayActive) {
        this.yearOverlayHeight = ''
        this.innerHeight = ''
      }

      // Emitted to App.vue
      EventBus.$emit('raceSelectOverlayProps', this.yearOverlayHeight, this.yearOverlayActive)
    },
    raceSelectRaceState (bool) {
      if (this.$refs.overlayRace === undefined) return

      // get height and set state of race select race overlay
      const overlayHeight = this.$refs.overlayRace.offsetHeight
      this.raceOverlayHeight = `${overlayHeight}px`
      this.innerHeight = `${overlayHeight}px`

      if (bool) {
        this.yearOverlayActive = false
        !this.raceOverlayActive ? this.raceOverlayActive = true : this.raceOverlayActive = false
      }

      // Reset styles
      if (!this.raceOverlayActive) {
        this.raceOverlayHeight = ''
        this.innerHeight = ''
      }

      // Emitted to App.vue
      EventBus.$emit('raceSelectOverlayProps', this.raceOverlayHeight, this.raceOverlayActive)
    },
    getCurrentYearRaces () {
      // Get index of current active season
      const findYear = this.seasons.map(function (e) { return e.season }).indexOf(this.activeSeason)
      this.activeSeasonIndex = findYear
    },
    seasonSelected (season, index) {
      this.activeSeason = season
      this.activeSeasonIndex = index

      // Emitted to RaceHeader.vue
      // EventBus.$emit('activateRaceOverlay', true)
      this.getValidRaces()
      this.getInvalidRaces()
      this.raceSelectRaceState(true)
    },
    raceRouting: function (i) {
      this.raceOverlayActive = false
      const path = `/${this.activeSeason}/${i}`

      // Don't run if same path
      if (this.$route.path !== path) {
        this.$router.push({
          name: 'otherRaces',
          params: {
            season: this.activeSeason,
            round: i
          }
        })
        // this.yearOverlayActive = false
        // this.raceOverlayActive = false

        // Emitted to App.vue
        EventBus.$emit('raceSelectOverlayProps', 'auto', false)

        // Remove events so they're not called multiple times on route change
        EventBus.$off('raceSelectYearState')
        EventBus.$off('raceSelectRaceState')
      }
    },
    getValidSeasons () {
      const seasons = this.seasons.filter((x) => {
        const season = parseInt(x.season)
        return season <= this.mostRecentSeason
      })
      this.validSeasons = seasons
    },
    getValidRaces () {
      const races = this.seasons[this.activeSeasonIndex].Races.filter((x) => {
        const round = parseInt(x.round)
        const activeYear = parseInt(this.activeSeason)
        if (activeYear === this.mostRecentSeason) {
          // Return only the latest race and previous races if active year is the current year
          return round <= this.mostRecentRound
        } else {
          // else return all
          return round
        }
      })
      this.validRaces = races
    },
    getInvalidRaces () {
      const races = this.seasons[this.activeSeasonIndex].Races.filter((x) => {
        const round = parseInt(x.round)
        const activeYear = parseInt(this.activeSeason)
        if (activeYear === this.mostRecentSeason) {
          // Return only the latest race and previous races if active year is the current year
          return round > this.mostRecentRound
        } else {
          return false
        }
      })
      this.invalidRaces = races
    }
  }
}
</script>
